import { render, staticRenderFns } from "./ValttikorttiPdf.vue?vue&type=template&id=25e85841&"
import script from "./ValttikorttiPdf.vue?vue&type=script&lang=js&"
export * from "./ValttikorttiPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports